/* eslint-disable dot-notation */
/* global process */
import fetch from 'cross-fetch'
import { RSAA } from 'redux-api-middleware'

import * as ActionTypes from './types'
import { getCookieData } from '../utils/handleCookies'

function workExperience(workExperienceString) {
  switch (workExperienceString) {
    case 'Student':
    case 'No work experience':
      return '0'
    case 'Less than 1':
      return '1'
    case '1-2':
      return '1 2'
    case '3-5':
      return '3 4 5'
    case '6-9':
      return '6 7 8 9'
    case '10+':
      return '10 11'
    default:
      return '0'
  }
}

function buildXML(data) {
  const dataArray = []
  for (const field in data) {
    dataArray.push(`<${field}>${data[field]}</${field}>`)
  }
  return dataArray.join('')
}

const sfAPI = data => ({
  [RSAA]: {
    types: [
      ActionTypes.CREATE_LEAD_REQUEST,
      ActionTypes.CREATE_LEAD_SUCCESS,
      ActionTypes.CREATE_LEAD_FAILURE
    ],
    endpoint: `${process.env.REACT_APP_SF_SERVICE}`,
    method: 'POST',
    headers: {
      'Content-Type': 'text/xml'
    },
    body: `<?xml version="1.0" encoding="utf-8"?>
    <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <CreateSkillsEnquiry xmlns="http://tempuri.org/">
          <enquiryData>${buildXML(data)}</enquiryData>
        </CreateSkillsEnquiry>
      </soap:Body>
    </soap:Envelope>`,
    fetch: async (...args) => fetch(...args)
  }
})

function buildDataObject(state, cookie, programCode) {
  const { user } = state

  const dataObject = {
    FirstName: user.firstName,
    LastName: user.lastName,
    Program: programCode,
    CountryCode: user.country,
    Email: user.email,
    WorkExperience: workExperience(user.experience),
    Source: `https://gmac.careermapper.io/report/${user.uuid}/${user.suid}`,
    PartnerCode: cookie.partnerCode,
    WebCampaign: cookie.firstwebCampaign,
    WebMedium: cookie.webMedium,
    WebTerm: cookie.webTerm,
    WebContent: cookie.webContent,
    WebAdgroup: cookie.webAdgroup,
    WebPlacement: cookie.webPlacement,
    FirstPartnerCode: cookie.firstpartnerCode,
    FirstWebCampaign: cookie.webCampaign,
    FirstWebMedium: cookie.firstwebMedium,
    FirstWebTerm: cookie.firstwebTerm,
    FirstWebContent: cookie.firstwebContent,
    FirstWebAdgroup: cookie.firstwebAdgroup,
    FirstWebPlacement: cookie.firstwebPlacement,
    ReferringUrl: encodeURIComponent(cookie.referringUrl),
    StartTerm: 'September 2020',
    Subject: 'Gmac Career Mapper'
  }

  if (user.phone) {
    dataObject.Phone = user.phone
  }

  if (user.countryState) {
    dataObject.State = user.countryState
  }

  return dataObject
}

export const createLead = () => (dispatch, getState) => {
  const { user, api } = getState()
  if (user.stored) return
  let recommendedProgramCode = ''
  const userCookie = getCookieData()

  const { recommendedPrograms } = api

  if (recommendedPrograms.programs && recommendedPrograms.programs.length) {
    recommendedProgramCode = recommendedPrograms.programs[0].hult_program_code
  }
  if (user.privacyPolicy) {
    return dispatch(
      sfAPI(buildDataObject(getState(), userCookie, recommendedProgramCode))
    )
  }
}
